import { CircularProgress } from "@mui/material";

export const Loader = () => <CircularProgress color="primary"/>